<template>
  <div>
    <!-- 页面标题和简介 -->
    <div class="page-header">
      <div class="container">
        <h1>亿会通 - 智能会议管理平台</h1>
        <p class="subtitle">为全球知名企业提供专业的会议管理解决方案，打造智能高效的数字化会务平台</p>
        <div class="stats">
          <div class="stat-item">
            <span class="stat-number">9+</span>
            <span class="stat-label">合作客户</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">20万+</span>
            <span class="stat-label">年会议量</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">100+</span>
            <span class="stat-label">覆盖城市</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">40+</span>
            <span class="stat-label">服务品类</span>
          </div>
        </div>
      </div>
    </div>
    
    

   

    <!-- 案例筛选 -->
    <div class="filter-section">
      <div class="container">
        <div class="filter-controls">
          <button 
            v-for="filter in filters" 
            :key="filter.id"
            :class="['filter-btn', { active: selectedFilter === filter.id }]"
            @click="selectedFilter = filter.id"
          >
            {{ filter.name }}
          </button>
        </div>
      </div>
    </div>

    <!-- 案例列表 -->
    <div class="about">
      <div 
        v-for="(caseItem, index) in filteredCases" 
        :key="index"
        :class="[index % 2 === 0 ? 'single-row' : 'double-row', 'case-card']"
        @click="showCaseDetail(caseItem)"
      >
        <div class="img-div">          
          <img :src="caseItem.image" :alt="caseItem.title">
          <div class="platform-title">
            <span>
              {{ caseItem.title }}<span>/ {{ caseItem.year }}</span>
            </span>
          </div>
          <div class="case-overlay">
            <span class="view-details">查看详情</span>
          </div>
        </div>
        <div class="case-content">
          <p v-for="(paragraph, pIndex) in caseItem.description" :key="pIndex">
            {{ paragraph }}
          </p>
          <div class="case-tags" v-if="caseItem.tags && caseItem.tags.length">
            <span v-for="(tag, tagIndex) in caseItem.tags" :key="tagIndex" class="tag">{{ tag }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 客户评价 -->
    <div class="testimonials">
      <div class="container">
        <h2>客户评价</h2>
        <div class="testimonial-cards">
          <div class="testimonial-card" v-for="(testimonial, index) in testimonials" :key="index">
            <div class="testimonial-content">{{ testimonial.content }}</div>
            <div class="testimonial-author">
              <div class="author-info">
                <div class="author-name">{{ testimonial.author }}</div>
                <div class="author-company">{{ testimonial.company }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="contact-section">
      <div class="container">
        <h2>了解更多解决方案</h2>
        <p>如果您对我们的平台服务感兴趣，欢迎联系我们获取更多信息</p>
        <button class="contact-btn">立即咨询</button>
      </div>
    </div>

    <!-- 返回顶部按钮 -->
    <button class="back-to-top" v-show="showBackToTop" @click="scrollToTop">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
    </button>

    <!-- 案例详情模态框 -->
    <div class="modal" v-if="selectedCase" @click="closeModal">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="closeModal">×</button>
        <div class="modal-header">
          <h3>{{ selectedCase.title }}</h3>
          <span class="modal-year">{{ selectedCase.year }}</span>
        </div>
        <div class="modal-body">
          <div class="modal-image">
            <img :src="selectedCase.image" :alt="selectedCase.title">
          </div>
          <div class="modal-description">
            <p v-for="(paragraph, pIndex) in selectedCase.description" :key="pIndex">{{ paragraph }}</p>
          </div>
          <div class="modal-features" v-if="selectedCase.features && selectedCase.features.length">
            <h4>功能特点</h4>
            <ul>
              <li v-for="(feature, fIndex) in selectedCase.features" :key="fIndex">{{ feature }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import Vue from 'vue'

export default {
  name: 'PlatformServices',
  components: {
    Footer
  },
  data() {
    return {
      cases: [
        {
          id: 1,
          title: '亿腾医药 亿会通 会议平台',
          year: '2026年',
          image: 'https://spkg.oss-accelerate.aliyuncs.com/resources/images/official/platform/edding.png',
          description: [
            '亿会通办会平台是专为亿腾医药量身定制的智能会务管理平台，深度融合了医药行业的合规要求和企业自身的管理规范。',
            '平台实现了从会议发起、审批、执行到结算的全流程数字化管理，覆盖了会议预约、场地选择、参会人员邀请、物料准备、用餐安排、用车调度等全方位功能。',
            '通过与亿腾医药内部系统的无缝对接，平台实现了数据的实时同步和共享，大幅提高了会议管理效率，同时确保了所有会议活动的合规性和可追溯性。',
            '自上线以来，平台已经处理了超过15,000场会议，帮助亿腾医药降低了30%的会议管理成本，提高了40%的工作效率，获得了企业内部的广泛认可。'
          ],
          tags: ['医药行业', '智能会务', '定制化平台'],
          features: ['会议预约', '用餐安排', '用车调度', '全流程管理', '合规监管']
        },
        {
          id: 2,
          title: '默沙东 Easy car 平台',
          year: '2019年',
          image: 'https://spkg.oss-accelerate.aliyuncs.com/resources/images/official/platform/1.jpg',
          description: [
            'Easy car项目是默沙东为优化企业内部车辆使用管理而发起的数字化转型项目，旨在解决传统车辆管理模式下存在的效率低下、成本高企、合规风险等问题。',
            '平台通过整合滴滴、神州等线上专车平台，以及覆盖全国超过100个城市的线下车队供应商，构建了一个统一的车辆服务网络。',
            '使用人可以通过平台完成用车的预定、使用、确认结算的全流程操作，同时企业管理人员可以实时监控车辆使用情况，生成详细的费用报表和合规报告。',
            '平台的使用不仅实现了车辆使用成本的有效控制，还大幅提高了员工的出行效率，同时通过数字化手段确保了所有车辆使用活动的合规性和透明度。',
            '截至目前，Easy car平台已经为默沙东节省了超过25%的车辆使用成本，员工满意度提升了45%，成为默沙东数字化转型的成功典范。'
          ],
          tags: ['医药行业', '车辆管理', '成本控制'],
          features: ['车辆整合', '全流程操作', '合规管理', '成本控制', '实时监控']
        },
        {
          id: 3,
          title: '辉瑞 YES 平台',
          year: '2016年',
          image: 'https://spkg.oss-accelerate.aliyuncs.com/resources/images/official/platform/2.jpg',
          description: [
            'YES平台是国内首创的全流程会议管理平台，也是辉瑞全球数字化转型战略的重要组成部分。平台以"提升效率、确保合规、优化体验"为核心目标，为辉瑞中国提供了一站式的会议管理解决方案。',
            '平台整合了会议策划、场地预订、人员管理、物料准备、费用结算等所有会议相关功能，实现了从会议发起至结束的全流程数字化管理。',
            '通过与辉瑞全球合规系统的对接，平台确保了所有会议活动严格遵守医药行业的合规要求，同时提供了丰富的数据分析和报表功能，帮助企业管理层做出更明智的决策。',
            'YES平台连续2年获得辉瑞全球的合规大奖，开创了端到端会议管理平台的先河。截至目前，平台年会议量近20万场，服务覆盖辉瑞中国所有业务部门和办事处。',
            '平台的成功实施不仅帮助辉瑞提高了会议管理效率，降低了运营成本，还为整个医药行业树立了数字化转型的标杆，引领了行业的创新发展。'
          ],
          tags: ['医药行业', '全流程会议', '合规管理'],
          features: ['端到端管理', '合规大奖', '高会议量', '行业首创', '数据分析']
        },
        {
          id: 4,
          title: '罗氏 A1平台',
          year: '2018年',
          image: 'https://spkg.oss-accelerate.aliyuncs.com/resources/images/official/platform/4.jpg',
          description: [
            '罗氏A1平台是罗氏制药为实现"简化流程、专注业务、提升效率"的目标而打造的一站式会议管理平台。平台以用户为中心，深度整合了罗氏内部的各类系统和外部资源。',
            '通过A1平台，罗氏员工可以轻松完成会议的策划、预订、执行和结算等全流程操作，无需在多个系统之间切换，大幅提高了工作效率。',
            '平台实现了全品类资源的整合及管理，包括会议场地、住宿、餐饮、交通、物料等，同时提供了智慧化的流程管理和合规监管功能，确保所有会议活动符合罗氏全球的合规要求。',
            'A1平台的上线标志着罗氏制药在中国的会议管理进入了数字化、智能化的新阶段。平台不仅提高了内部管理效率，还为罗氏的客户和合作伙伴提供了更好的会议体验。',
            '截至目前，A1平台已经覆盖罗氏中国所有业务部门，年处理会议量超过12万场，帮助罗氏节省了20%的会议管理成本，员工满意度提升了35%。'
          ],
          tags: ['医药行业', '一站式平台', '流程简化'],
          features: ['流程简化', '资源整合', '端到端操作', '多系统整合', '用户中心']
        },
        {
          id: 5,
          title: '礼来 Easy meeting 平台',
          year: '2018年',
          image: 'https://spkg.oss-accelerate.aliyuncs.com/resources/images/official/platform/5.jpg',
          description: [
            'Easy meeting平台是礼来制药为优化会议管理流程、提升会议质量而开发的数字化平台。平台整合了礼来内部的会议管理规范和外部的优质资源，为礼来员工提供了便捷、高效、合规的会议管理服务。',
            '平台通过整合酒店、交通、用餐、现场执行人等会议资源，实现了覆盖全国的会议服务网络。用户可以通过平台完成会议的全流程操作，包括会议申请、审批、预订、执行和结算。',
            'Easy meeting平台采用了先进的大数据分析技术，可以根据用户的历史会议数据和偏好，智能推荐会议方案，提高会议策划的效率和质量。',
            '作为2019年度礼来global最为重要的数字化变革创新产品，Easy meeting平台受到了礼来总部的极大关注和高度评价。平台的成功实施不仅帮助礼来提高了会议管理效率，还为礼来的全球数字化转型提供了宝贵经验。',
            '截至目前，Easy meeting平台已经覆盖礼来中国所有业务部门，年处理会议量超过10万场，帮助礼来节省了22%的会议管理成本，提高了30%的会议策划效率。'
          ],
          tags: ['医药行业', '会议资源整合', '智能推荐'],
          features: ['资源整合', '全流程操作', '全国覆盖', '数字化变革', '智能推荐']
        },
        {
          id: 6,
          title: '诺华制药 MEETING GO 平台',
          year: '2019年',
          image: 'https://spkg.oss-accelerate.aliyuncs.com/resources/images/official/platform/6.jpg',
          description: [
            'MEETING GO平台是诺华制药为打造全新会议操作模式而开发的数字化平台。平台一期上线品类包括酒店、外出用餐及外卖、会议交通，以及会议服务人员，全面覆盖了会议管理的各个方面。',
            '平台采用了"便捷前端、集中管理、智能分析"的设计理念，既方便了前端销售人员的使用，又实现了企业对会议活动的集中管理和控制。',
            '通过MEETING GO平台，销售人员可以轻松预订会议场地、安排用餐和交通，无需繁琐的审批流程；企业管理人员可以实时监控会议费用和执行情况，一键发起结算，一键汇总数据。',
            '平台的实施完美实现了诺华制药要求的费用节省、合规管理、提高效能的三大要求。截至目前，平台已经覆盖诺华中国所有销售团队，帮助诺华节省了28%的会议管理成本，提高了40%的工作效率。',
            'MEETING GO平台的成功实施标志着诺华制药在中国的会议管理进入了数字化、智能化的新时代，为诺华的业务发展提供了有力支持。'
          ],
          tags: ['医药行业', '智能会议', '集中管理'],
          features: ['多品类覆盖', '集中管理', '一键结算', '费用节省', '便捷操作']
        },
        {
          id: 7,
          title: '平安集团 MICE 平台',
          year: '2019年',
          image: 'https://spkg.oss-accelerate.aliyuncs.com/resources/images/official/platform/7.jpg',
          description: [
            '平安集团MICE平台是平安集团与中智商展战略合作的重要成果，旨在解决平安集团在MICE领域每年支出巨大、管理分散、合规风险高等问题。',
            '平台由双方团队共同设计和研发，整合了平安集团的内部资源和中智商展的专业服务能力，为平安集团提供了全方位的MICE管理解决方案。',
            '平台的核心功能包括MICE活动的策划、预订、执行、结算和分析等全流程管理，通过数字化手段实现了对MICE活动的集中管理和控制。',
            '双方的战略合作不仅包括MICE平台的设计研发，还包括技术运维及服务中心的建立，全国人才网络的使用、MICE落地服务、支付等多个领域的全面合作。',
            '平安集团MICE平台的成功实施不仅帮助平安集团降低了MICE活动的成本，强化了监管，提升了用户体验，还整合了分散的数据，为平安集团的决策提供了有力支持。'
          ],
          tags: ['金融行业', 'MICE平台', '战略合作'],
          features: ['战略合作', '成本降低', '强化监管', '数据整合', '全面覆盖']
        },
        {
          id: 8,
          title: '艾尔建 艾微会 平台',
          year: '2018年',
          image: 'https://spkg.oss-accelerate.aliyuncs.com/resources/images/official/platform/8.jpg',
          description: [
            '艾微会平台是艾尔建为优化小型会议和商务宴请管理而开发的数字化平台。平台以"灵活、便捷、合规"为核心价值，为艾尔建员工提供了高效的小型会议和商务宴请管理服务。',
            '平台于2018年8月上线，初期覆盖全国40个城市，主要提供小型会议场地预订、商务宴请安排等服务。平台的上线解决了艾尔建在小型会议和商务宴请管理方面存在的流程繁琐、成本不透明、合规风险高等问题。',
            '通过艾微会平台，艾尔建员工可以轻松预订小型会议场地和安排商务宴请，无需繁琐的审批流程；企业管理人员可以实时监控费用情况，确保所有活动符合艾尔建的合规要求。',
            '艾微会平台的上线标志着艾尔建在中国的小型会议和商务宴请管理进入了数字化阶段。平台不仅提高了内部管理效率，还为艾尔建的客户和合作伙伴提供了更好的服务体验。',
            '截至目前，艾微会平台已经覆盖艾尔建中国所有业务部门，年处理小型会议和商务宴请超过8万场，帮助艾尔建节省了18%的相关成本，员工满意度提升了30%。'
          ],
          tags: ['医药行业', '商务宴请', '小型会议'],
          features: ['全国覆盖', '40+城市', '小会管理', '商务宴请', '灵活便捷']
        },
        {
          id: 9,
          title: '活动兔 Eventcool 平台',
          year: '2019年',
          image: 'https://spkg.oss-accelerate.aliyuncs.com/resources/images/official/platform/9.jpg',
          description: [
            '活动兔Eventcool平台是一款面向中小企业和个人用户的一站式会议服务平台，旨在解决用户在会议策划和执行过程中面临的资源难找、流程繁琐、成本高等问题。',
            '平台整合了全国范围内的优质会议资源，包括会议场地、设备租赁、餐饮服务、活动执行等，用户可以通过平台轻松找到适合自己需求的资源。',
            '活动兔平台提供了专业的会议顾问一对一全程跟踪服务，协助用户在线免费生成会议方案。平台的智能推荐系统可以根据用户的需求和预算，快速匹配最适合的会议资源。',
            '自上线以来，活动兔平台已经服务了超过10,000家企业和个人用户，举办了超过20,000场会议活动，获得了用户的广泛好评。平台的成功证明了数字化、平台化的会议服务模式具有广阔的市场前景。',
            '活动兔平台的使命是"让会议更简单"，通过不断创新和优化，平台将继续为用户提供更好的会议服务体验，助力用户成功举办各类会议活动。'
          ],
          tags: ['会议服务', '在线平台', '中小企业'],
          features: ['一站式服务', '专业顾问', '一对一跟踪', '免费方案', '智能推荐']
        }
      ],
      filters: [
        { id: 'all', name: '全部案例' },
        { id: 'pharmaceutical', name: '医药行业' },
        { id: 'financial', name: '金融行业' },
        { id: 'all-in-one', name: '一站式平台' },
        { id: 'meeting', name: '会议管理' },
        { id: 'transport', name: '交通服务' }
      ],
      selectedFilter: 'all',
      selectedCase: null,
      showBackToTop: false,
      testimonials: [
        {
          content: '通过使用该平台，我们的会议管理效率提升了60%，成本降低了30%，这是一个真正改变行业的创新解决方案。',
          author: '张经理',
          company: '默沙东中国'
        },
        {
          content: '平台的易用性和稳定性超出了我们的预期，它帮助我们实现了会议管理的数字化转型。',
          author: '李总监',
          company: '辉瑞制药'
        },
        {
          content: '作为金融行业用户，我们对合规性要求极高，该平台完美满足了我们的需求。',
          author: '王总监',
          company: '平安集团'
        }
      ]
    }
  },
  computed: {
    filteredCases() {
      if (this.selectedFilter === 'all') {
        return this.cases
      }
      // 根据筛选条件过滤案例
      const filterMap = {
        'pharmaceutical': ['医药行业'],
        'financial': ['金融行业'],
        'all-in-one': ['一站式平台'],
        'meeting': ['全流程会议', '会议资源整合', '智能会议', '会议服务'],
        'transport': ['车辆管理']
      }
      
      return this.cases.filter(caseItem => {
        return caseItem.tags.some(tag => filterMap[this.selectedFilter].includes(tag))
      })
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showBackToTop = window.scrollY > 300
    },
    scrollToTop() {
      Vue.nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      })
    },
    showCaseDetail(caseItem) {
      this.selectedCase = caseItem
    },
    closeModal() {
      this.selectedCase = null
    }
  }
}
</script>
<style lang="less" scoped>
/* 通用容器样式 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页面标题部分 */
.page-header {
  background: linear-gradient(135deg, #39C5D5 0%, #2B8BC3 100%);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
  
  h1 {
    font-size: 42px;
    margin-bottom: 16px;
    font-weight: 700;
  }
  
  .subtitle {
    font-size: 18px;
    margin-bottom: 40px;
    opacity: 0.9;
  }
  
  .stats {
    display: flex;
    justify-content: center;
    gap: 60px;
    flex-wrap: wrap;
    
    .stat-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      
      .stat-number {
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 8px;
      }
      
      .stat-label {
        font-size: 14px;
        opacity: 0.8;
      }
    }
  }
}


/* 筛选部分 */
.filter-section {
  background: #f8f9fa;
  padding: 30px 0;
  
  .filter-controls {
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
    
    .filter-btn {
      padding: 10px 20px;
      border: 1px solid #ddd;
      background: white;
      border-radius: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 14px;
      
      &:hover {
        border-color: #39C5D5;
        color: #39C5D5;
      }
      
      &.active {
        background: #39C5D5;
        color: white;
        border-color: #39C5D5;
      }
    }
  }
}

/* 案例列表 */
.about {
  margin-top: 0;
}

.case-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  .img-div {
    position: relative;
    // overflow: hidden;
    
    &:hover .case-overlay {
      opacity: 1;
    }
    
    &:hover img {
      transform: scale(1.05);
    }
    
    img {
      transition: transform 0.5s ease;
      width: 100%;
      height: auto;
      display: block;
    }
    
    .case-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(57, 197, 213, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
      
      .view-details {
        color: white;
        font-size: 18px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 1px;
      }
    }
  }
  
  .case-content {
    
    p {
      transition: color 0.3s ease;
      
      &:hover {
        color: #39C5D5;
      }
    }
    
    .case-tags {
      margin-top: 20px;
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
          width: 72%;
    margin: 10px auto;
      
      .tag {
        background: #e3f5f7;
        color: #39C5D5;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
      }
    }
  }
}

/* 客户评价部分 */
.testimonials {
  background: #f8f9fa;
  padding: 80px 0;
  
  h2 {
    text-align: center;
    font-size: 32px;
    margin-bottom: 50px;
    color: #333;
  }
  
  .testimonial-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    
    .testimonial-card {
      background: white;
      padding: 30px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
      }
      
      .testimonial-content {
        font-size: 16px;
        line-height: 26px;
        color: #666;
        margin-bottom: 20px;
        font-style: italic;
      }
      
      .testimonial-author {
        display: flex;
        align-items: center;
        
        .author-info {
          .author-name {
            font-weight: 600;
            color: #333;
            margin-bottom: 4px;
          }
          
          .author-company {
            font-size: 14px;
            color: #999;
          }
        }
      }
    }
  }
}

/* 联系我们部分 */
.contact-section {
  background: linear-gradient(135deg, #39C5D5 0%, #2B8BC3 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
  
  h2 {
    font-size: 32px;
    margin-bottom: 16px;
  }
  
  p {
    font-size: 18px;
    margin-bottom: 30px;
    opacity: 0.9;
  }
  
  .contact-btn {
    background: white;
    color: #39C5D5;
    padding: 15px 40px;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    }
  }
}

/* 模态框 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  
  .modal-content {
    background: white;
    border-radius: 8px;
    max-width: 800px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    
    .close-btn {
      position: absolute;
      top: 15px;
      right: 20px;
      font-size: 30px;
      background: none;
      border: none;
      cursor: pointer;
      color: #999;
      transition: color 0.3s ease;
      
      &:hover {
        color: #333;
      }
    }
    
    .modal-header {
      padding: 30px 30px 20px;
      border-bottom: 1px solid #eee;
      
      h3 {
        font-size: 24px;
        margin-bottom: 8px;
        color: #333;
      }
      
      .modal-year {
        color: #999;
        font-size: 14px;
      }
    }
    
    .modal-body {
      padding: 30px;
      
      .modal-image {
        margin-bottom: 20px;
        
        img {
          width: 100%;
          border-radius: 4px;
        }
      }
      
      .modal-description {
        margin-bottom: 30px;
        
        p {
          margin-bottom: 16px;
          line-height: 24px;
          color: #666;
        }
      }
      
      .modal-features {
        h4 {
          font-size: 18px;
          margin-bottom: 16px;
          color: #333;
        }
        
        ul {
          list-style: none;
          padding: 0;
          
          li {
            padding: 8px 0;
            padding-left: 25px;
            position: relative;
            color: #666;
            
            &::before {
              content: '✓';
              position: absolute;
              left: 0;
              color: #39C5D5;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: #39C5D5;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 999;
  
  &:hover {
    background: #2B8BC3;
    transform: translateY(-3px);
  }
}

/* 响应式设计 */
@media (max-width: 997px) {
  .page-header {
    padding: 60px 0 40px;
    
    h1 {
      font-size: 32px;
    }
    
    .subtitle {
      font-size: 16px;
    }
    
    .stats {
      gap: 40px;
      
      .stat-item {
        .stat-number {
          font-size: 28px;
        }
      }
    }
  }
  
  .case-card .img-div img {
    max-width: 100%;
  }
  
  .app-intro .intro-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

@media(min-width: 767px) {
  .single-row {
    background: #F4F4F4;
    padding: 60px 0;
  }
  
  .double-row {
    background: #FFFFFF;
    padding: 60px 0;
  }
  
  p {
    width: 72%;
    margin: 0 auto;
    font-size: 16px;
    color: #666666;
    line-height: 28px;
  }
  
  p+p {
    margin-top: 20px;
  }
  
  .img-div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56%;
    margin: 0 auto;
    position: relative;
    margin-bottom: 40px;
  }
  
  .platform-title {
    position: absolute;
    bottom: -18px;
    width: 100%;
    text-align: center;
    height: 27px!important;
  }
  
  .platform-title span {
    background: #39C5D5;
    color: #FFFFFF;
    padding: 7px 13px;
    font-size: 20px;
  }
  
  .platform-title span span {
    font-size: 16px;
  }
}

@media(max-width: 767px) {
  .single-row {
    background: #F4F4F4;
    padding: 40px 0;
  }
  
  .double-row {
    background: #FFFFFF;
    padding: 40px 0;
  }
  
  p {
    padding: 0 20px;
    margin: 0 auto;
    font-size: 14px;
    color: #666666;
    line-height: 26px;
  }
  
  p+p {
    margin-top: 16px;
  }
  
  .img-div {
    position: relative;
    margin: 0 20px;
    margin-bottom: 30px;
  }
  
  .img-div img {
    width: 100%;
  }
  
  .platform-title {
    position: absolute;
    bottom: -18px;
    width: 100%;
    text-align: center;
    height: 27px!important;
  }
  
  .platform-title span {
    background: #39C5D5;
    color: #FFFFFF;
    padding: 6px 12px;
    font-size: 16px;
  }
  
  .platform-title span span {
    font-size: 12px;
  }
  
  .page-header {
    .stats {
      gap: 30px;
      
      .stat-item {
        .stat-number {
          font-size: 24px;
        }
        
        .stat-label {
          font-size: 12px;
        }
      }
    }
  }
  
  .app-intro {
    padding: 40px 0;
    
    h2 {
      font-size: 24px;
      margin-bottom: 30px;
    }
    
    .intro-content {
      grid-template-columns: 1fr;
      gap: 30px;
    }
  }
  
  .services-info {
    padding: 40px 0;
    
    h2 {
      font-size: 24px;
      margin-bottom: 30px;
    }
    
    .services-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }
    
    .service-item {
      padding: 20px;
    }
  }
  
  .testimonials {
    .testimonial-cards {
      gap: 20px;
      
      .testimonial-card {
        padding: 20px;
      }
    }
  }
  
  .contact-section {
    padding: 60px 0;
    
    h2 {
      font-size: 24px;
    }
    
    p {
      font-size: 16px;
    }
  }
}

@media(max-width: 596px) {
  .platform-title span {
    font-size: 14px;
    padding: 5px 10px;
  }
  
  .platform-title span span {
    font-size: 10px;
  }
  
  .page-header {
    h1 {
      font-size: 28px;
    }
  }
  
  .modal {
    padding: 10px;
    
    .modal-content {
      .modal-header,
      .modal-body {
        padding: 20px;
      }
    }
  }
}
</style>